import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Modal, Row, Select, Button, List, Text, message, Checkbox, Divider, Alert, Icon } from 'antd';
import { billingFunctions } from 'utils/constants';
const { confirm } = Modal;

const ProductModal = ({ data, visibility, offVisible, form, onSubmit, selectedProduct, resetProduct, onDelete, productCategoryData }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subProductRow, setSubProductRow] = useState([]);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (selectedProduct) {
      // Find and set the selected category FIRST
      const category = productCategoryData.find(cat => cat._id === selectedProduct.category);
      setSelectedCategory(category || null);

      // Set initial values for non-dynamic fields
      form.setFieldsValue({
        name: selectedProduct.name,
        code: selectedProduct.code,
        category: selectedProduct.category || '-',
        description: selectedProduct.description
      });

      // Use setTimeout to ensure conditional fields are rendered before setting values
      setTimeout(() => {
        form.setFieldsValue({
          functions: selectedProduct.functions || []
        });

        // Handle dynamic subProduct fields
        if (selectedProduct.subProduct && selectedProduct.subProduct.subCode) {
          const subProductCount = selectedProduct.subProduct.subCode.length;
          setSubProductRow([...Array(subProductCount)].map((_, index) => index));
          setCounter(subProductCount);

          selectedProduct.subProduct.subCode.forEach((code, index) => {
            form.setFieldsValue({
              [`subCode[${index}]`]: code,
              [`subDescription[${index}]`]: selectedProduct.subProduct.subDescription[index] || ''
            });
          });
        }
      }, 0);
    } else {
      form.resetFields();
      setSelectedCategory(null);
      setSubProductRow([]);
      setCounter(0);
    }
  }, [selectedProduct, productCategoryData]);

  const handleOk = async e => {
    form.validateFields((err, values) => {
      console.log(values);
      if (!err) {
        const { subCode, subDescription, ...restValues } = values;

        const filteredSubCode = (subCode || []).filter(item => item !== null);
        const filteredSubDescription = (subDescription || []).filter(item => item !== null);

        const subProduct = {
          subCode: filteredSubCode,
          subDescription: filteredSubDescription
        };

        const functions = restValues.functions || [];
        if (selectedCategory && selectedCategory.parent[0] === 'hostProtect' && !functions.includes('hostProtect')) {
          functions.push('hostProtect');
        }

        const updatedValues = {
          ...restValues,
          functions,
          subProduct
        };

        onSubmit(updatedValues, !selectedProduct ? 'new' : selectedProduct._id);
        setSubProductRow([]);
        setCounter(0);
        form.resetFields();
        offVisible();
        resetProduct();
      }
    });
  };

  const handleCancel = e => {
    offVisible();
    resetProduct();
  };

  const handleConfirmDelete = () => {
    confirm({
      title: 'Are you sure you want to delete this product?',
      content: 'This action cannot be undone.',
      onOk() {
        handleDelete();
        resetProduct();
      },
      onCancel() {
        console.log('Cancel');
      }
    });
  };

  const handleDelete = () => {
    offVisible();
    onDelete(selectedProduct._id);
  };

  const handleCategoryChange = value => {
    const selected = productCategoryData.find(category => category._id === value);
    setSelectedCategory(selected);
    setSubProductRow([]);
    setCounter(0);
    form.setFieldsValue({ category: value });
  };

  const subProduct = index => {
    return (
      <>
        {/* Body - dynamically create rows based on rowCount */}
        <>
          <Col
            span={12}
            style={{
              borderLeft: '1px solid #ccc',
              borderBottom: '1px solid #ccc',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height: '90px'
            }}
          >
            <Form.Item style={{ marginBottom: 0 }}>
              {getFieldDecorator(`subCode[${index}]`, {
                rules: [{ message: 'Please Input Sub Code' }]
              })(<Input style={{ textAlign: 'center' }} placeholder="Sub Code" />)}
            </Form.Item>
          </Col>

          <Col
            span={12}
            style={{
              borderLeft: '1px solid #ccc',
              borderRight: '1px solid #ccc',
              borderBottom: '1px solid #ccc',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '16px',
              height: '90px',
              position: 'relative' // Allows positioning the button inside
            }}
          >
            <Form.Item style={{ marginBottom: 0, width: '100%' }}>
              {getFieldDecorator(`subDescription[${index}]`, {
                rules: [{ required: true, message: 'Please Input Sub Description' }]
              })(<Input.TextArea rows={1} style={{ textAlign: 'center', resize: 'none' }} placeholder="Sub Description" />)}
            </Form.Item>

            {/* Mini '-' button */}
            <Button
              type="danger"
              size="small"
              onClick={() => handleRemove(index)}
              style={{
                position: 'absolute',
                top: '2px',
                right: '1px',
                padding: '2px 4px', // Small padding to fit the button nicely
                fontSize: '12px', // Font size should be readable
                height: '15px', // Adjust height to ensure button content fits
                width: '18px',
                lineHeight: '1' // Makes sure the text is vertically centered
              }}
            >
              -
            </Button>
          </Col>
        </>
      </>
    );
  };

  const handleRemove = index => {
    const { getFieldValue } = form;

    const currentSubCode = getFieldValue('subCode'); // assuming this is an array of strings/numbers
    const currentSubDescription = getFieldValue('subDescription'); // assuming this is an array of strings/numbers

    // Use filter directly on the arrays, not on individual elements
    const updatedSubCode = currentSubCode.map((item, i) => (i === index ? null : item));
    const updatedSubDescription = currentSubDescription.map((item, i) => (i === index ? null : item));

    // Update the form fields
    form.setFieldsValue({
      subCode: updatedSubCode,
      subDescription: updatedSubDescription
    });

    // Update the subProductRow state
    setSubProductRow(prevRow => prevRow.filter((_, i) => _ !== index));
  };

  const { getFieldDecorator } = form;
  return (
    <>
      <Modal
        title={!selectedProduct ? 'New Product' : selectedProduct.name}
        visible={visibility}
        onCancel={handleCancel}
        footer={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <Button key="submit" type="primary" onClick={handleOk}>
                {!selectedProduct ? 'Create' : 'Update'}
              </Button>
            </div>
            {selectedProduct && (
              <Button key="delete" type="danger" onClick={handleConfirmDelete}>
                Delete
              </Button>
            )}
          </div>
        }
      >
        <Form autoComplete="off">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Product Name">
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Please input the product name' }]
                })(<Input placeholder="Product Name" />)}
              </Form.Item>
              {selectedCategory && selectedCategory.parent[0] === 'system' && (
                <Alert
                  message="Naming Format Required"
                  description='Product name must follow the format: "HOSTPLATFORM - [Product Name]" (e.g. "HOSTPLATFORM - Core", "HOSTPLATFORM - Engine", "HOSTPLATFORM - Prime")'
                  type="info"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}
            </Col>
            <Col span={12}>
              <Form.Item label="Code">
                {getFieldDecorator('code', {
                  rules: [{ message: 'Please input the code' }]
                })(<Input placeholder="Code" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Category">
                {getFieldDecorator('category', {
                  rules: [{ required: true, message: 'Please select the category' }]
                })(
                  <Select placeholder="Select Category" onChange={handleCategoryChange}>
                    {productCategoryData.map(category => (
                      <Select.Option key={category._id} value={category._id}>
                        {category.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>

            {/* Header */}
            <Col span={24}>
              <Form.Item label="Sub Product">
                {/* Wrap layout inside a parent div or Fragment */}
                <>
                  {/* Sub product rows */}
                  {subProductRow.length > 0 && (
                    <>
                      {/* Header */}
                      <Col
                        span={12}
                        style={{
                          borderTop: '1px solid #ccc',
                          borderLeft: '1px solid #ccc',
                          borderBottom: '1px solid #ccc',
                          padding: '2px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <span>Code</span>
                      </Col>
                      <Col
                        span={12}
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <span>Description</span>
                      </Col>
                      {/* Sub-products */}
                      {subProductRow.map(index => subProduct(index))}
                    </>
                  )}
                  {/* Add Sub Product Button */}
                  <Button
                    onClick={() => {
                      setSubProductRow([...subProductRow, counter]); // Add a new product row
                      setCounter(counter + 1); // Increment the counter
                    }}
                    type="dashed"
                    style={{ width: '100%' }}
                  >
                    <Icon type="plus" /> Add Sub Product
                  </Button>
                </>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label="Description">
                {getFieldDecorator('description', {
                  rules: [{ required: false, message: 'Please input the description' }]
                })(<Input.TextArea rows={4} placeholder="Description" />)}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Divider />
            </Col>
            {selectedCategory && selectedCategory.parent[0] === 'system' && (
              <Col span={24}>
                <Form.Item label="Functions">
                  {getFieldDecorator('functions', {
                    rules: [{ required: false }]
                  })(
                    <Checkbox.Group>
                      <Row>
                        {billingFunctions
                          .filter(option => option.value !== 'hostProtect')
                          .map(option => (
                            <Col span={12} key={option.value} style={{ padding: '4px 0' }}>
                              <Checkbox value={option.value}>{option.label}</Checkbox>
                            </Col>
                          ))}
                      </Row>
                    </Checkbox.Group>
                  )}
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
        {selectedCategory && selectedCategory.parent[0] === 'system' && (
          <Alert
            message="System Category Selected"
            description="Please contact tech team for integration to IM, if this product is newly created."
            type="warning"
            showIcon
            style={{ marginTop: 16 }}
          />
        )}
      </Modal>
    </>
  );
};

export default Form.create()(ProductModal);
